import React from "react";

import { Spinner } from "components";

import "assets/scss/components/buttons/generalButton.scss";
import { isStringTrimNotEmpty } from "functions";
import { Toaster } from "components/notification/Toaster";



export function Button(props) {
    const { className, id, isLoading, isDisabled, disabledMsg, isSpinnerColorPrimary } = props;

    // Decoration
    const { isDecoration_secondary, isDecoration_action, isDecoration_important, isDecoration_disabled,
        isDecoration_darkTransparent, isDecoration_lightTransparent, isDecoration_transparentDarkGreyBorder,
        isDecoration_primaryTransparent 
    } = props;

    function handleOnClick() {
        if (props.handleOnClick && !isDisabled)
            props.handleOnClick();
        else if (isStringTrimNotEmpty(disabledMsg)) {
            Toaster({
                type: "error",
                msg: disabledMsg
            })
        }
    }

    return (
        <div id={id} className={"component-generalButton"}>
            <button 
                className={"component-generalButtonWrapper text-overflow-ellipsis text-center " + 
                    (className? className + " ":"") +
                    (isDisabled? "decoration_disabled ":"") +
                    (isDecoration_secondary? "decoration_secondary ":"") +
                    (isDecoration_action? "decoration_action ":"") +
                    (isDecoration_important? "decoration_important ":"") + 
                    (isDecoration_darkTransparent? "decoration_darkTransparent ":"") +
                    (isDecoration_lightTransparent? "decoration_lightTransparent ":"") +
                    (isDecoration_primaryTransparent? "decoration_primaryTransparent ":"") +
                    (isDecoration_disabled? "decoration_disabled ":"") +
                    (isDecoration_transparentDarkGreyBorder? "decoration_transparentDarkGreyBorder ":"")}
                onClick={handleOnClick}
            >
                {props.children} {isLoading && <Spinner isColorPrimary={isSpinnerColorPrimary} size={0} />}
            </button>
        </div>
    );
}